import { CellFn, GraphDefinition } from "@/graphHandling/graphTypes.ts";
import { ReactElement } from "react";
import { map } from "ramda";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckIcon from "@mui/icons-material/Check";

export const trackingFunction = (
  cellFnResults: Record<string, ReturnType<CellFn>>,
  processDefinition: GraphDefinition,
  isErroneous?: boolean
): Array<ReactElement> => {
  return map(cellId => {
    const icon = isErroneous ? (
      <ErrorOutlineIcon style={{ color: "red" }} />
    ) : (
      <CheckIcon style={{ color: "green" }} />
    );
    return (
      <li key={`${cellId}-${Math.random()}`}>
        {icon} {processDefinition.cells[cellId].name}
        {isErroneous ? `: Prosessin osan suorittaminen epäonnistui` : ""}
      </li>
    );
  }, Object.keys(cellFnResults));
};
